<template>
    <div class="notification" v-click-outside="closeDropDown">
        <i
            class="notification__button"
            :class="{ 'notification__button_indicator': notifications?.unreadcount > 0 }"
            @click="isActive = !isActive"
        >
            <svg class="icon">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-ring"></use>
            </svg>
        </i>
        <div class="notification__content" v-if="isActive">
            <div class="notification__top">
                <h3 class="title notification__title">{{ $t('notifications.title') }}</h3>
                <div class="notification__control">
                    <div
                        v-if="notifications?.unreadcount > 0"
                        @click="readNotifications"
                        class="notification__icon notification__icon_square notification__icon_bg_green notification__sucsess">
                        <svg class="icon icon_color_green">
                            <use xlink:href="/img/sprites/icons-sprite.svg#icon-sucsess"></use>
                        </svg>
                    </div>
<!--                    <div class="notification__icon notification__icon_bg_gray notification__setting">-->
<!--                        <svg class="icon">-->
<!--                            <use xlink:href="/img/sprites/icons-sprite.svg#icon-setting"></use>-->
<!--                        </svg>-->
<!--                    </div>-->
                </div>
            </div>
            <template v-if="notifications?.notifications?.length > 0">
                <div class="notification__list max-h-[800px] overflow-auto pr-1">
                    <div @click="naviagateTo(item)" class="notification__item"
                         v-for="(item, index) in notifications.notifications"
                         :key="`notify-${index}`">
                        <div class="notification__icon notification__icon_circle notification__icon_bg_gray w-[35px] h-[35px] flex items-center justify-center overflow-hidden">
                            <img :src="item.iconurl" alt="" class="w-[70%] object-contain">
                        </div>

                        <div class="notification__col">
                            <p class="text text_thickness notification__text">{{ item.shortenedsubject }}</p>
                            <div class="notification__row">
                                <div class="notification__date">{{
                                        dateFormater(item.timecreated, false, locale)
                                    }}
                                </div>
                                <btn-wrapper
                                    :params="{
                                        class: 'link link_text-color_blue link_text-size_small link_thickness',
                                        type: 'link',
                                        path: '',
                                        title: $t('notifications.more')
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <btn-wrapper
                    @click="navToCalendar"
                    :params="{
                    class: 'button button_bg_blue-light button_round_small button_text-color_blue notification__link',
                    type: 'link',
                    path: '#',
                    title: $t('notifications.btn')
                }"
                />
            </template>
            <div v-else>
                <h4>{{ $t('notifications.empty') }}</h4>
            </div>
        </div>
        <Modal :title="itemToShow?.shortenedsubject"
            :buttons="{
                cancel: true
            }"
            v-model="showModal" @cancel="showModal = false"
        >
            <p class="text-notifaction" v-html="itemToShow?.fullmessagehtml"></p>
            <p style="margin-top: 1rem">{{ itemToShow.timecreatedpretty }}</p>
        </Modal>
    </div>
</template>

<script setup>
import BtnWrapper from '../../BtnWrapper.vue'
import {computed, ref} from 'vue'
import {useStore} from "vuex";
import {dateFormater} from "@/script";
import {useRouter} from "vue-router";
import Modal from "@/components/UI/modal/index.vue"
import {useI18n} from "vue-i18n";


const store = useStore()
const router = useRouter()
const itemToShow = ref(null)
const showModal = ref(false);
const user = computed(() => store.getters.user)
const notifications = computed(() => store.getters.notifications)
const isActive = ref(false)
const {locale} = useI18n()


const navToCalendar = () => {
    router.push('/calendar')
    isActive.value = false
}

const naviagateTo = item => {
    const parsedData = JSON.parse(item.customdata)

    if (parsedData?.cmid) {
        store.dispatch('getCourseModuleInfo', parsedData.cmid).then(res => {
            router.push(`/course/${parsedData.courseid}/${res.cm.modname}/${res.cm.id}`)
        })
    } else {
        itemToShow.value = item
        showModal.value = true
        isActive.value = false
    }
}

const readNotifications = () => {
    const id = user.value.id
    store.dispatch('readAllNotifications', id)
    store.dispatch('getNotification')
}

const closeDropDown = () => isActive.value = false
</script>

<style lang="scss" scoped>
@import '../scss/notification.scss';

.text-notifaction:deep(a) {
    color: #00AEEF;
    display: inline;
}
</style>
